<template>
  <div class="pd-15">
    <div v-bind:class="{'card': hasCaption}">
      <div class="card-header" v-if="hasCaption">
        {{caption}}
      </div>
      <div v-bind:class="{'card-body': hasCaption}">
      <form @submit="submitLine">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label">Common Fee Names </label>
              <select class="form-control form-control-sm" v-model="lineItem.feeCategoryId" @change="updateCategory(lineItem.feeCategoryId)">
                <option value="">Select a fee...</option>
                <option v-for="cat in categories" :value="cat.id" v-bind:key="cat.id">
                  {{cat.dropdownValue}}
                </option>
                <option value="">Custom Fee</option>
              </select>
              <div class="text-muted">A list of fees often seen on statements.</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label">Fee Description </label>
              <input class="form-control form-control-sm" v-model="lineItem.description" required/>
              <div class="text-muted">If the fee isn't on the list, enter a description here.</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label">Fee Type </label>
              <select class="form-control form-control-sm" v-model="lineItem.lineItemType">
                <option value="interchange">Interchange</option>
                <option value="assessments">Assessments</option>
                <option value="monthly">Monthly</option>
                <option value="other">Other Nonsense</option>
              </select>
              <div class="text-muted">Type of fee.  There are many.</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2" v-if="volumeEnabled">
            <div class="form-group">
              <label class="form-control-label">Volume</label>
              <small-currency-input v-model="lineItem.volume"/>
              <div class="text-muted">Transaction volume this fee is based on.</div>
            </div>
          </div> <!-- col -->
          <div class="col-md-2" v-if="countEnabled">
            <div class="form-group">
              <label class="form-control-label">Transaction Count</label>
              <input class="form-control form-control-sm" v-model="lineItem.transactionCount" @blur="recalcTotal()"/>
              <div class="text-muted">Number of transactions this fee is based on.</div>
            </div>
          </div> <!-- col -->
          <div class="col-md-2" v-if="countEnabled">
            <div class="form-group">
              <label class="form-control-label">Transaction Fee</label>
              <small-currency-input v-model="lineItem.actualPerTransaction" @blur="recalcTotal()"/>
              <div class="text-muted">Per transaction fee on the statement.</div>
            </div>
          </div> <!-- col -->
          <div class="col-md-2" v-if="volumeEnabled">
            <div class="form-group">
              <label class="form-control-label">Transaction Percentage</label>
              <percent-input v-model="lineItem.actualPercentage" @blur="recalcTotal()"/>
              <div class="text-muted">Fee as a percentage of the transaction.</div>
            </div>
          </div> <!-- col -->
          <div class="col-md-2">
            <div class="form-group">
              <label class="form-control-label">Line Item Total</label>
              <small-currency-input v-model="lineItem.actualTotal" @blur="checkActualTotal()"/>
              <div class="text-muted">Total for this line item on your statement.</div>
            </div>
          </div> <!-- col -->
          <div class="col-md-2">
            <div class="form-group">
              <button class="btn btn-sm btn-success mg-t-30"><i class="fa fa-save"></i> SAVE</button>
            </div>
          </div> <!-- col -->
        </div>
      </form>
      </div>
    </div>
  </div>
</template>


<script>
import SmallCurrencyInput from '@/components/SmallCurrencyInput'
import PercentInput from '@/components/SmallPercentInput'

export default {
  name: 'enter-statement-line-item',
  props: ['id', 'categories', 'caption'],
  components: {
    'small-currency-input': SmallCurrencyInput,
    'percent-input': PercentInput
  },
  data: () => ({
    selectedCategory: null,
    manualTotal: false,
    computedTotal: null,
    lineItem: {
      actualTotal: null,
      feeCategoryId: '',
      lineItemType: 'other'
    }
  }),
  computed: {
    hasCaption: function () {
      if (this.caption) {
        return true
      } else {
        return false
      }
    },
    volumeEnabled: function () {
      if (!this.selectedCategory) {
        return true
      }
      return this.selectedCategory.volumeEnabled
    },
    countEnabled: function () {
      if (!this.selectedCategory) {
        return true
      }
      return this.selectedCategory.countEnabled
    }
  },
  methods: {
    submitLine: function (e) {
      e.preventDefault()
      this.$emit("addLineItem", this.lineItem)
      this.manualTotal = false
      this.computedTotal = 0
      this.lineItem = {
        actualTotal: null,
        feeCategoryId: '',
        lineItemType: 'other'
      }
    },
    checkActualTotal: function () {

      if (this.lineItem.actualTotal !== this.computedTotal) {
        this.manualTotal = true
      }

    },
    recalcTotal: function() {

      let result = 0
      let expectedResult = 0

      if (this.lineItem.volume && this.lineItem.actualPercentage) {
        result = result + ( (parseFloat(this.lineItem.volume) * parseFloat(this.lineItem.actualPercentage) / 100) )
      }

      if (this.lineItem.volume && this.lineItem.expectedPercentage) {
        expectedResult = expectedResult + ( (parseFloat(this.lineItem.volume) * parseFloat(this.lineItem.expectedPercentage) / 100) )
      }

      if (this.lineItem.transactionCount && this.lineItem.actualPerTransaction) {
        result = result + ( parseFloat(this.lineItem.transactionCount) * parseFloat(this.lineItem.actualPerTransaction) )
      }

      if (this.lineItem.transactionCount && this.lineItem.expectedPerTransaction) {

        expectedResult = expectedResult + ( parseFloat(this.lineItem.transactionCount) * parseFloat(this.lineItem.expectedPerTransaction) )
      }

      this.computedTotal = result.toFixed(2)
      this.lineItem.expectedTotal = expectedResult.toFixed(2)
      if (!this.manualTotal) {
        this.lineItem.actualTotal = result.toFixed(2)
      }

    },
    updateCategory: function (catId) {
      for (var i = 0; i < this.categories.length; i++) {
        if (this.categories[i].id === catId) {
          this.selectCategory(this.categories[i])
          return
        }
      }
      this.selectCategory(null)
    },
    selectCategory: function (cat) {
      this.selectedCategory = cat
      if (cat) {
        this.lineItem.description = cat.name
        this.lineItem.actualPerTransaction = cat.defaultTransactionFee
        this.lineItem.actualPercentage = cat.defaultTransactionPercentage
        this.lineItem.expectedPerTransaction = cat.defaultTransactionFee
        this.lineItem.expectedPercentage = cat.defaultTransactionPercentage
        if ( (cat.categoryType === 'interchange') || (cat.categoryType === 'assessments') ) {
          this.lineItem.lineItemType = cat.categoryType
        } else {
          this.lineItem.lineItemType = 'other'
        }
      }

    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
